module.exports = __webpack_public_path__ + "img/tea4.e8838968.png";